import Actualite from '@/generated/classes/Actualite';
export default class ActualiteExtend extends Actualite {
  constructor() {
    super();
  }
}
